"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.SelectDownshiftComponentCustom = exports.defaultComponents = exports.SelectDownshiftMenu = void 0;
var react_1 = __importStar(require("react"));
var react_popper_1 = require("react-popper");
var react_2 = require("../../../util/react");
var SelectMenu_1 = require("../SelectMenu");
var SelectMenuItem_1 = require("../SelectMenu/SelectMenuItem");
var styles_1 = require("../../../styles");
function SelectDownshiftMenu(props) {
    var items = props.items, isLoading = props.loading, menuMinWidth = props.menuMinWidth, anchorRef = props.anchorRef, components = props.components, createNewItem = props.createNewItem, popperProps = props.popperProps, _a = props.downshift, isOpen = _a.isOpen, getMenuProps = _a.getMenuProps;
    var _b = __assign(__assign({}, exports.defaultComponents), components), CreateItem = _b.CreateItem, LoadingItem = _b.LoadingItem, EmptyItem = _b.EmptyItem, Item = _b.Item, PrependItem = _b.PrependItem, AppendItem = _b.AppendItem;
    var _c = react_1.useState(), menuRef = _c[0], setMenuRef = _c[1];
    var _d = react_popper_1.usePopper(anchorRef.current, menuRef, __assign({ placement: 'bottom-start' }, popperProps)), popperStyle = _d.styles.popper, placement = _d.attributes.placement;
    var _e = getMenuProps({ refKey: 'dropdownMenuRef' }, { suppressRefError: true }), dropdownMenuRef = _e.dropdownMenuRef, menuProps = __rest(_e, ["dropdownMenuRef"]);
    var _f = styles_1.useStyles(exports.createStyles), classes = _f.classes, css = _f.css;
    return (react_1.default.createElement(react_1.default.Fragment, null, isOpen && (react_1.default.createElement("div", __assign({}, menuProps, { "data-placement": placement, ref: react_2.composeRefs(dropdownMenuRef, setMenuRef), className: css(classes.menu), style: __assign(__assign({}, popperStyle), { width: anchorRef.current && anchorRef.current.clientWidth, minWidth: menuMinWidth }) }),
        PrependItem && react_1.default.createElement(PrependItem, __assign({}, props)),
        react_1.default.createElement(SelectMenu_1.SelectMenu, { style: classes.list },
            isLoading && react_1.default.createElement(LoadingItem, __assign({}, props)),
            !isLoading && createNewItem && (items || []).length > 0 && react_1.default.createElement(CreateItem, __assign({}, props)),
            !isLoading && !createNewItem && (items || []).length === 0 && react_1.default.createElement(EmptyItem, __assign({}, props)),
            items && items.map(function (item, index) { return react_1.default.createElement(Item, __assign({ key: index, index: index, item: item }, props)); })),
        AppendItem && react_1.default.createElement(AppendItem, __assign({}, props))))));
}
exports.SelectDownshiftMenu = SelectDownshiftMenu;
exports.defaultComponents = {
    AppendItem: function () { return null; },
    PrependItem: function () { return null; },
    CreateItem: function (props) { return react_1.default.createElement(SelectMenuItem_1.SelectCreateItem, null); },
    LoadingItem: function (props) { return react_1.default.createElement(SelectMenu_1.SelectLoadingItem, null); },
    EmptyItem: function (props) { return react_1.default.createElement(SelectMenu_1.SelectEmptyItem, null); },
    Item: function (props) {
        var renderItem = props.renderItem, item = props.item, index = props.index, _a = props.downshift, itemToString = _a.itemToString, highlightedIndex = _a.highlightedIndex, getItemProps = _a.getItemProps;
        return (react_1.default.createElement(SelectMenu_1.SelectMenuItem, __assign({ selected: highlightedIndex === index }, getItemProps({ item: item })), renderItem ? renderItem(item) : itemToString(item)));
    },
};
function SelectDownshiftComponentCustom(props) {
    var theme = styles_1.useTheme();
    return (react_1.default.createElement("div", __assign({ style: {
            background: theme.pallete.surface.background,
            padding: '0.25rem 0.5rem',
            cursor: 'initial',
        } }, props)));
}
exports.SelectDownshiftComponentCustom = SelectDownshiftComponentCustom;
exports.createStyles = function (theme) { return ({
    menu: {
        display: 'flex',
        flexDirection: 'column',
        zIndex: theme.zIndex.dropdown,
        border: "1px solid " + theme.pallete.divider,
        borderRadius: theme.radius.popper,
        backgroundColor: theme.pallete.surface.main,
        boxShadow: theme.shadows.outer['40'],
        maxHeight: '20rem',
    },
    list: {
        zIndex: 'auto',
        border: 0,
        borderRadius: 0,
        boxShadow: 'none',
        maxHeight: 'auto',
    },
}); };
SelectDownshiftMenu.defaultProps = {
    components: exports.defaultComponents,
};
//# sourceMappingURL=SelectDownshiftMenu.js.map